import React from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';
import airportImage from '../../assets/services/airport.jpg';
import { FaPlane, FaClock, FaSuitcase, FaCarAlt } from 'react-icons/fa';

function NavetteAeroport() {
  const features = [
    {
      icon: <FaPlane />,
      title: "Tous les Aéroports",
      description: "Service de transfert vers Genève, Zürich, Bâle et autres aéroports"
    },
    {
      icon: <FaClock />,
      title: "24/7 Disponible",
      description: "Service disponible jour et nuit, 7 jours sur 7, toute l'année"
    },
    {
      icon: <FaSuitcase />,
      title: "Bagages Inclus",
      description: "Espace généreux pour vos bagages et équipements"
    },
    {
      icon: <FaCarAlt />,
      title: "Confort Premium",
      description: "Véhicules haut de gamme avec chauffeurs professionnels"
    }
  ];

  return (
    <main className="service-page">
      {/* Hero Section */}
      <section className="service-hero" style={{ backgroundImage: `url(${airportImage})` }}>
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <h1>Navette Aéroport</h1>
          <p>Transferts aéroport confortables et ponctuels</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content">
        <div className="service-container">
          {/* Description */}
          <div className="service-description">
            <h2>Service de Transfert Aéroport Premium</h2>
            <p>
              Simplifiez vos déplacements vers et depuis les aéroports avec notre service 
              de navette premium. Nous assurons des transferts ponctuels et confortables 
              vers tous les aéroports de la région.
            </p>
            <p>
              Notre service comprend la prise en charge à domicile, l'assistance bagages 
              et le suivi en temps réel de vos vols pour garantir votre tranquillité d'esprit.
            </p>
          </div>

          {/* Features Grid */}
          <div className="service-features">
            {features.map((feature, index) => (
              <div key={index} className="service-feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="service-cta">
            <h2>Réservez Votre Transfert</h2>
            <p>
              Planifiez votre transfert aéroport dès maintenant pour un voyage sans stress.
            </p>
            <div className="cta-buttons">
              <a href="tel:+41797774444" className="cta-button secondary">
                +41 79 777 44 44
              </a>
              <Link to="/quote" className="cta-button primary">
                Demander un Devis
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default NavetteAeroport; 